module.exports = __webpack_public_path__ + "static/IMG_2517-3cb3241547f194ac99f07b709a43a782.jpg";